<template>
  <div  >
    <Header></Header>
    <Title title="考试记录"></Title>
    <div class="contain_main">
      <div class="search" @keydown.enter="changepage(1)">
        <div class="search_item">
          <div class="item">
            <span>考试名称:</span>
            <Input v-model="data.examtitle" placeholder="请输入..." style="width:2rem"/>
          </div>
          <div class="item">
            <div @click="changepage(1)" class="button">搜索</div>
          </div>
        </div>
      </div>
      <div class="table">
        <table>
          <thead>
            <tr>
              <td>考试编号</td>
              <td>考试名称</td>
              <td>考试时间</td>
              <td>阅卷状态</td>
              <td>考试用时</td>
              <td>考试得分</td>
              <td>及格状态</td>
              <td>操作</td>
            </tr>
          </thead>
          <!-- ehispass	string	true	0不及格1及格null阅卷中
            ehscore	string	true	考分
            ehdecide	number	true	0阅卷中1已阅卷2无需阅卷
            examendtime	number	true	考试结束时间
            examstartime	number	true	考试开始时间
            ehendtime	number	true	答卷结束时间
            ehstartime	number	true	答卷考试时间
            examtitle	string	true	考试标题
          ehid	number	true	考试记录id-->
          <tbody>
            <tr v-for="(item,index) in list" :key="index">
              <td>{{item.ehid}}</td>
              <td>
                <Tooltip :content="item.examtitle" placement="top-start">
                  <span class="tableName">{{item.examtitle}}</span>
                </Tooltip>
              </td>
              <td>{{formate(item.ehstartime)+"~"+formate(item.ehendtime)}}</td>
              <td>{{item.ehdecide|yuejuan}}</td>
              <td>{{(item.ehendtime - item.ehstartime)|time}}分钟</td>
              <td>{{item.ehdecide==0?'未评分':item.ehscore}}</td>
              <td :style="{color:item.ehispass==0?'red':item.ehispass==1?'green':'#707788'}">{{item.ehispass|jige}}</td>
              <td>
                <button @click="topage(item.ehdecide,item.ehid)">查看试卷</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class style="text-align:right;margin-top:20px;">
        <Page
          :total="total"
          :current='data.page'
          @on-change="changepage"
          @on-page-size-change="changesize"
          show-sizer
          show-elevator
          show-total
          :page-size-opts="[5,10, 20,50]"
        />
      </div>
      <div style="height:200px"></div>
    </div>
  </div>
</template>
<script>
import Header from "../../components/header";
import Title from "../../components/title";
import { ExamHistory_index } from "../../assets/js/api.js";
import fun from "../../assets/js/fun.js";
export default {
  name: "testlist",
  data() {
    return {
      list: [],
      total: null,
      data: {
        examtitle: "", //	string	true	普通参数		考试标题
        page: 1, //	string	true	普通参数		页码
        size: 10 //	string	true	普通参数		条数
      }
    };
  },
  filters: {
    yuejuan(data) {
      //   0阅卷中1已阅卷2无需阅卷
      switch (data) {
        case 0:
          return "阅卷中";
        case 1:
          return "已阅卷";
        case 2:
          return "无需阅卷";
      }
    },
    jige(data) {
      //  0不及格1及格2未评分
      switch (data) {
        case 0:
          return "不及格";
        case 1:
          return "及格";
        case 2:
          return "未评分";
      }
    },

    time(data) {
      return Math.round(data / 60);
    }
  },
  components: {
    Header,
    Title
  },
  mounted() {
    this.getlist();
  },
  methods: {
    formate(data) {
      return fun.formatetime(data);
    },
    changepage(data) {
      this.data.page = data;
      this.getlist();
    },
    changesize(data) {
      this.data.page = 1;
      this.data.size = data;
      this.getlist();
    },
    getlist() {
      ExamHistory_index(this.data).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.list;
          this.total = res.data.data.count;
          return 
        }
        //    this.$Notice.warning({ title: "信息提示", desc: res.data.message });
        this.$Notice.warning({
            title: '信息提示',
            desc: res.data.message
        });
      });
    },
    topage(status, id) {
      // 0阅卷中1已阅卷2无需阅卷
      if (status == 0) {
        this.$router.push("/Recordexampaper?id=" + id);
      } else if (status == 1 || status == 2) {
        this.$router.push("/recordpaper?id=" + id);
      } else {
        this.errorPlus("阅卷状态未定,不可查看详情！");
      }
    }
  }
};
</script>
<style lang="css" scoped>
/* 搜索栏样式------------------------------------------------------------------------------------------- */
.search {
  margin-top: 0.2rem;
  display: flex;
  color: #575e6b;
}
.search .search_item {
  display: flex;
}
.search .search_item .item {
  margin: 0 0.15rem;
}
.button {
  width: 0.9rem;
  height: 0.3rem;
  color: #fff;
  background: #4b51ff;
  line-height: 0.3rem;
  border-radius: 0.02rem;
  font-size: 0.14rem;
}
/* 表格栏目样式----------------------------------------------------------------------------------------------*/
.table {
  margin-top: 0.6rem;
  font-size: 0.14rem;
}
table {
  width: 100%;
}
thead tr {
  color: #a4acbf;
}
tbody tr {
  color: #707788;
}
tr {
  height: 0.6rem;
}
/*查看详情button-----------------------------------------------------------------------------------------------------------------*/
button {
  color: #25b3f9;
  background: #d3f3fc;
  border-radius: 0.5rem;
  border: none;
  padding: 0.04rem 0.1rem;
  font-size: 0.14rem;
  outline: none;
}
</style>


// WEBPACK FOOTER //
// src/pages/records/recordlist.vue